import { Link } from "react-router-dom";
import { Type } from "@shared/ui/Type";
import { Button } from "@shared/ui/Button";
import { Loader } from "@shared/ui/Loader";
import { OuterContentContainer } from "@shared/ui/OuterContentContainer";
import { MeetingDetails } from "@platform/features/video/types/video.types";
import { PhaseAction } from "@platform/types/platform.types";
import { VideoUIEndQuizAction } from "./VideoUIEndQuizAction";

export type Props = {
  meetingDetails: MeetingDetails | null;
  meetingSurveyUserPhaseAction: PhaseAction | null;
};

export function VideoUIEnd({
  meetingDetails,
  meetingSurveyUserPhaseAction,
}: Props) {
  if (!meetingDetails) {
    return null;
  }

  return (
    <div className="flex flex-col items-start justify-center flex-1 py-8 md:items-center">
      <OuterContentContainer innerClassName="flex flex-col-reverse gap-8 w-auto md:flex-row md:gap-0 md:items-stretch md:border md:border-brand-800 md:rounded-md md:p-0 md:shadow-lg">
        <div className="flex flex-col gap-8 w-full md:min-w-lg md:max-w-xl md:gap-8 md:px-12 md:py-8">
          <div className="flex flex-1 flex-col gap-4 items-center text-center">
            <Type variant="body2">{meetingDetails.title}</Type>
            <Type as="h1" variant="h3">
              The meeting has ended.
            </Type>
            <Type variant="body1">
              Thank you for attending.{" "}
              {meetingDetails.meeting_type !== "meeting_standalone" &&
                "Please take a moment to fill out this 3-minute feedback survey."}
            </Type>
          </div>
          <div className="flex flex-col gap-4">
            {meetingDetails.meeting_type !== "meeting_standalone" &&
              (meetingSurveyUserPhaseAction ? (
                <VideoUIEndQuizAction action={meetingSurveyUserPhaseAction} />
              ) : (
                <Loader />
              ))}
            <Button as={Link} to="/dashboard" variant="secondary">
              Go to Dashboard
            </Button>
          </div>
        </div>
      </OuterContentContainer>
    </div>
  );
}

export default VideoUIEnd;
